(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button.localization-button'),
        panel: this.querySelector('ul'),
        submit: this.querySelector('button[type="submit"]')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      this.elements.submit.addEventListener('click', this.submitForm.bind(this));
      
    }

    submitForm(event) {
      event.preventDefault();
      this.querySelector('form')?.submit();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      // this.querySelector('form')?.submit();
    }

    openSelector(event) {
      console.clear();
      console.log(event);
      // this.elements.button.focus();
      // this.elements.panel.toggleAttribute('hidden');
      // this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bar"] && !Shopify.designMode) return;
  try {
    
// Handle opening/closing dropdowns (supports multiple option sets like Color, Size, etc.)

  window.variantColorHandler = function () {
    document.querySelectorAll(".product__swatch").forEach(function (element) {
        element.addEventListener("click", function(event){
            event.preventDefault();
            let productSwatchColor = element.querySelector(".product__swatch-color");
            if(productSwatchColor){
                let dataValue = productSwatchColor.dataset.value;
                let productInfoWrapper = document.querySelector(".product__info-wrapper");
                if(dataValue && productInfoWrapper){
                  let colorInputMain = productInfoWrapper.querySelector(`input[name="Color"][data-color-handle="${dataValue}"]`);
                  if(colorInputMain){
                    colorInputMain.click();
                  }
                  let closestProductSwatches = element.closest(".product__swatches");
                  if(closestProductSwatches){
                    let activeProductSwatchesButtonSticky = closestProductSwatches.querySelector(".product__swatches-button-sticky.active");
                    let activeProductColorSwatchesDropdown = closestProductSwatches.querySelector(".product__color-swatches-dropdown.show");
                    if(activeProductSwatchesButtonSticky){
                      activeProductSwatchesButtonSticky.classList.remove("active");
                    }
                    if(activeProductColorSwatchesDropdown){
                      activeProductColorSwatchesDropdown.classList.remove("show");
                    }
                  }
                }
            }
        })
    });
  }

  window.variantStickyBarHandler = function () {
    document.querySelectorAll(".product__swatches-button-sticky").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        const dropdown = button.nextElementSibling;
    
        // Close all other dropdowns
        document.querySelectorAll(".product__swatches-dropdown").forEach(function (el) {
          if (el !== dropdown) {
            el.classList.remove("show");
          }
        });
    
        // Remove active class from other buttons
        document.querySelectorAll(".product__swatches-button-sticky").forEach(function (btn) {
          if (btn !== button) {
            btn.classList.remove("active");
          }
        });
    
        // Toggle current button and dropdown
        button.classList.toggle("active");
        dropdown.classList.toggle("show");
      });
    });

    if (typeof window.variantColorHandler === 'function') {
      window.variantColorHandler();
    }
    
      // Variant selection
    document.querySelectorAll('.product__swatches-dropdown input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('click', function () {
    
        let currentValue = radio.value;
        if(currentValue){
          let matchingVariantInput = document.querySelector(`.product-form__input[data-option="Size"] input[value="${currentValue}"]`);
          if(matchingVariantInput){
            matchingVariantInput.click();
          }
        }
        
        const group = radio.closest('.product__swatches-dropdown');
        const allRadios = group.querySelectorAll('.product__swatches-dropdown input[type="radio"]');
    
        allRadios.forEach(function (r) {
          r.checked = false;
        });
    
        radio.checked = true;
        // Close dropdown
        const button = group.closest('.product__swatches').querySelector('.product__swatches-button-sticky');
        const dropdown = group;
        button.classList.remove('active');
        dropdown.classList.remove('show');
      });
    }); 
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.variantStickyBarHandler === 'function') {
      window.variantStickyBarHandler();
    }
    let headroom = new Headroom(document.querySelector('.product-bar'), { offset: 350 });
    headroom.init();
  });


  } catch(e) { console.error(e); }
})();
})();
